// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7c35d74a","455":"942b95f4","977":"918b83de"}[chunkId] + ".chunk.js";
};